<section>
  <ng-content></ng-content>

  @if (visible) {
    <ion-button
      fill="clear"
      size="small"
      (click)="clearAll()"
    >
      <tr-icon slot="icon-only" class="tr-icon" [icon]="icon.cancel"></tr-icon>
    </ion-button>
  }
</section>
